import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { logout, isAdmin } from '../helpers/auth'
import { db } from '../services/firebase'


export default class ChatControls extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isAdmin: isAdmin()
        }
    }
    clearAll = async () => {
        if (!this.state.isAdmin) {
            return
        }
        if (!window.confirm("Admin: Clear all messages?")) {
            return
        }
        try {
            await db.ref("chat").set({})
        } catch (error) {
            alert(error.message)
        }
    }

    logoutClicked = async () => {
        await logout()
    }

    render() {
        return (
            <div>
                <Grid container >
                    <Grid item xs={1}>
                        <Button variant="contained" color="secondary" onClick={this.logoutClicked}>
                            Logout
                        </Button>
                    </Grid>
                    {this.state.isAdmin ?
                        <Grid item xs={4}>
                            <Button variant="contained" color="secondary" onClick={this.clearAll}>
                                Admin: Delete All Message
                        </Button>
                        </Grid>
                        : null}
                </Grid>
            </div>
        )
    }
}
